<template>
  <div></div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Logout',
  mounted () {
    this.$http.post('/auth/logout').then(() => {
      window.localStorage.setItem('token', '');
      Vue.prototype.$http.defaults.headers.Authorization = 'Bearer none';
      this.$router.push({ name: 'Logowanie' });
    }).catch((error) => {
      console.error(error);
      window.localStorage.setItem('token', '');
      Vue.prototype.$http.defaults.headers.Authorization = 'Bearer none';
      this.$router.push({ name: 'Logowanie' });
    });
  }
};
</script>
